module.exports = __webpack_public_path__ + "static/img/jiatingqinjie.7c81ba4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jiatingqinjie.png
// module id = z4LR
// module chunks = 0